import React, { useEffect } from "react";
import Landing from "./pages/Landing.jsx";
import EditorV2 from "./pages/EditorV2.jsx";
import DecorEditor from "./pages/DecorEditor.jsx";
import DecorLanding from "./pages/DecorLanding.jsx";
import DecorProjects from "./pages/DecorProjects.jsx";
import InteriorStudio from "./pages/InteriorStudio.jsx";
import MediaLibrary from "./pages/MediaLibrary.jsx";
import Gallerie from "./pages/Gallerie.jsx";
import TripoStudio from "./pages/TripoStudio.jsx";
import NanoBanana from "./pages/NanoBanana.jsx";
import VideoStudio from "./pages/VideoStudio.jsx";
import VideoMontage from "./pages/VideoMontage.jsx";
import Labyrinthe from "./pages/Labyrinthe.jsx";
import FoyerIA from "./pages/FoyerIA.jsx";
import Pricing from "./pages/Pricing.jsx";
import MusicStudio from "./pages/MusicStudio.jsx";
import Legal from "./pages/Legal.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import CvAntoineCailliez2026 from "./pages/cv-antoine-cailliez-2026.jsx";
import MicropousseForm from "./pages/MicropousseForm.jsx";
import LandingGames from "./pages/games/LandingGames.jsx";
import { trackPageView } from "./services/analytics.js";

export default function App() {
  useEffect(() => {
    if (window.__fetch401Hooked) return;
    window.__fetch401Hooked = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
    const isPublicPath = window.location.hostname === "games.aczart.fr" || window.location.pathname === "/" || window.location.pathname === "/legal" || window.location.pathname === "/decor-landing" || window.location.pathname === "/reset-password" || window.location.pathname === "/cv-antoine-cailliez-2026" || window.location.pathname === "/micropousses" || window.location.pathname === "/games";
    if (response.status === 401 && !isPublicPath) {
        window.location.assign("/");
    }
      return response;
    };
    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function open(...openArgs) {
      this.__track401 = true;
      return originalOpen.apply(this, openArgs);
    };
    window.XMLHttpRequest.prototype.send = function send(...sendArgs) {
      this.addEventListener("load", () => {
        const isPublicPath = window.location.hostname === "games.aczart.fr" || window.location.pathname === "/" || window.location.pathname === "/legal" || window.location.pathname === "/decor-landing" || window.location.pathname === "/reset-password" || window.location.pathname === "/cv-antoine-cailliez-2026" || window.location.pathname === "/micropousses" || window.location.pathname === "/games";
        if (this.__track401 && this.status === 401 && !isPublicPath) {
          window.location.assign("/");
        }
      });
      return originalSend.apply(this, sendArgs);
    };
  }, []);
  useEffect(() => {
    trackPageView();
  }, []);
  useEffect(() => {
    const isPublicRoute =
      window.location.hostname === "games.aczart.fr" ||
      window.location.pathname === "/" ||
      window.location.pathname === "/legal" ||
      window.location.pathname === "/decor-landing" ||
      window.location.pathname === "/reset-password" ||
      window.location.pathname === "/cv-antoine-cailliez-2026" ||
      window.location.pathname === "/micropousses" ||
      window.location.pathname === "/games";
    if (isPublicRoute) return () => { };
    let intervalId;

    async function refreshSession() {
      try {
        const res = await fetch("/api/auth/refresh", {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        });
        if (!res.ok) throw new Error("Refresh failed");
        const data = await res.json();
        if (!data?.user) throw new Error("No user");
      } catch {
        window.location.assign("/");
      }
    }

    refreshSession();
    intervalId = window.setInterval(refreshSession, 25 * 60 * 1000);
    return () => {
      if (intervalId) window.clearInterval(intervalId);
    };
  }, []);
  const isDecoHostname = window.location.hostname === "deco.aczart.fr";
  const isGamesHostname = window.location.hostname === "games.aczart.fr";
  const isEditorRoute = window.location.pathname.startsWith("/editor");
  const isDecorLandingRoute = window.location.pathname === "/decor-landing";
  const isDecorProjectsRoute = window.location.pathname === "/decor/projects";
  const isProjectsRoute = window.location.pathname === "/projects";
  const isDecorRoute = window.location.pathname.startsWith("/decor");
  const isMediaRoute = window.location.pathname.startsWith("/media");
  const isNanoRoute = window.location.pathname.startsWith("/nano");
  const isVideoRoute = window.location.pathname.startsWith("/video");
  const isMontageRoute = window.location.pathname.startsWith("/montage");
  const isGallerieRoute = window.location.pathname.startsWith("/gallerie");
  const isTripoRoute = window.location.pathname.startsWith("/tripo");
  const isLabyrintheRoute = window.location.pathname.startsWith("/labyrinthe");
  const isInteriorRoute = window.location.pathname.startsWith("/interior");
  const isFoyeriaRoute = window.location.pathname.startsWith("/foyeria");
  const isPricingRoute = window.location.pathname.startsWith("/pricing");
  const isMusicRoute = window.location.pathname.startsWith("/music");
  const isLegalRoute = window.location.pathname.startsWith("/legal");
  const isResetRoute = window.location.pathname.startsWith("/reset-password");
  const isCvRoute = window.location.pathname === "/cv-antoine-cailliez-2026";
  const isMicropousseRoute = window.location.pathname === "/micropousses";
  const isGamesRoute = window.location.pathname === "/games" || isGamesHostname;
  let page;
  if (isCvRoute) page = <CvAntoineCailliez2026 />;
  else if (isMicropousseRoute) page = <MicropousseForm />;
  else if (isGamesRoute) page = <LandingGames />;
  else if (isEditorRoute) page = <EditorV2 />;
  else if (isDecorLandingRoute) page = <DecorLanding />;
  else if (isDecorProjectsRoute) page = <DecorProjects />;
  else if (isProjectsRoute) page = <DecorProjects />;
  else if (isDecorRoute) page = <DecorEditor />;
  else if (isMediaRoute) page = <MediaLibrary />;
  else if (isGallerieRoute) page = <Gallerie />;
  else if (isTripoRoute) page = <TripoStudio />;
  else if (isNanoRoute) page = <NanoBanana />;
  else if (isMontageRoute) page = <VideoMontage />;
  else if (isVideoRoute) page = <VideoStudio />;
  else if (isLabyrintheRoute) page = <Labyrinthe />;
  else if (isInteriorRoute) page = <InteriorStudio />;
  else if (isFoyeriaRoute) page = <FoyerIA />;
  else if (isPricingRoute) page = <Pricing />;
  else if (isMusicRoute) page = <MusicStudio />;
  else if (isLegalRoute) page = <Legal />;
  else if (isResetRoute) page = <ResetPassword />;
  else page = isDecoHostname ? <DecorLanding /> : <Landing />;

  const isPwa = window.matchMedia("(display-mode: standalone)").matches;
  return (
    <>
      {page}
      {isPwa && (
        <button
          className="pwa-back-btn"
          onClick={() => history.back()}
          aria-label="Retour"
        >
          <span className="material-symbols-rounded">arrow_back</span>
        </button>
      )}
    </>
  );
}
